/**
 * MC Accordion — expand/collapse items via max-height transition.
 */

function initAccordions() {
	const items = document.querySelectorAll( '.mc-accordion__item' );

	items.forEach( ( item ) => {
		const header = item.querySelector( '.mc-accordion__header' );
		const panel = item.querySelector( '.mc-accordion__panel' );
		if ( ! header || ! panel ) {
			return;
		}

		if ( item.classList.contains( 'is-open' ) ) {
			panel.style.maxHeight = panel.scrollHeight + 'px';
		}

		header.addEventListener( 'click', () => {
			const willOpen = ! item.classList.contains( 'is-open' );

			// Single-open: close any other open item in the same accordion.
			if ( willOpen ) {
				const root = item.closest( '.mc-accordion' );
				if ( root ) {
					root.querySelectorAll( '.mc-accordion__item.is-open' ).forEach( ( other ) => {
						if ( other === item ) {
							return;
						}
						other.classList.remove( 'is-open' );
						const op = other.querySelector( '.mc-accordion__panel' );
						if ( op ) {
							op.style.maxHeight = '0px';
						}
						const oh = other.querySelector( '.mc-accordion__header' );
						if ( oh ) {
							oh.setAttribute( 'aria-expanded', 'false' );
						}
					} );
				}
			}

			item.classList.toggle( 'is-open', willOpen );
			header.setAttribute( 'aria-expanded', willOpen ? 'true' : 'false' );
			panel.style.maxHeight = willOpen ? panel.scrollHeight + 'px' : '0px';
		} );
	} );

	window.addEventListener( 'resize', () => {
		document.querySelectorAll( '.mc-accordion__item.is-open .mc-accordion__panel' ).forEach( ( p ) => {
			p.style.maxHeight = 'none';
			const h = p.scrollHeight;
			p.style.maxHeight = h + 'px';
		} );
	} );
}

document.addEventListener( 'DOMContentLoaded', initAccordions );
